import {Card, Grid, Dropdown, Button, Loader} from 'semantic-ui-react';
import {monthOptions, yearsOptions} from '../../utils/static';
import {dealerListForForcastSale} from '../../../common/constants/lists';
import ConsolidatedTable from '../consolidatedTable';
import ReactDataSheet from 'react-datasheet';
import React from 'react';
import {addTotalCols} from '../../utils/sumDetail';

export const renderHeader = ({
  yearFilter,
  monthFilter,
  rucFilter,
  loading,
  saving,
  renderSaveButton,
  handleSearchClick,
  handleFilterSelection,
  getDealers,
  salesType,
}) => {
  return (
    <Card raised fluid>
      <div className='title-bar'>
        <div className='title'>
          <h2>Proyección de ventas de vehículos {salesType}</h2>
          <div className='title-bar-actions'>
            {renderSaveButton()}
            <Button secondary
              disabled={!yearFilter || !monthFilter || loading || saving}
              onClick={handleSearchClick}
            >
            Buscar
            </Button>
          </div>
        </div>
        <div className='filters-section'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={1}>
                <h4>Cliente</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Dropdown selection
                  name='rucFilter'
                  value={rucFilter}
                  onChange={handleFilterSelection}
                  disabled={loading || saving}
                  options={getDealers()}
                />
              </Grid.Column>
              <Grid.Column width={1}>
                <h4>Año</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Dropdown selection
                  options={yearsOptions}
                  name='yearFilter'
                  value={yearFilter}
                  onChange={handleFilterSelection}
                  disabled={loading || saving}
                />
              </Grid.Column>
              <Grid.Column width={1}>
                <h4>Mes</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Dropdown selection
                  options={monthOptions}
                  name='monthFilter'
                  value={monthFilter}
                  onChange={handleFilterSelection}
                  disabled={loading || saving}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    </Card>
  );
};

const renderSpreadSheet = ({
  dealer,
  data,
  dates,
  loading,
  agenciesList,
  renderCellContent,
  handleCellsChange,
}) => {
  if (!dates.length || !data || data.length <= 3) {
    return null;
  }
  
  const dataWithTotalCols = addTotalCols(dates, data, agenciesList);
  
  if (loading) {
    return (
      <Card raised fluid>
        <Loader active inline='centered' />
      </Card>
    );
  }
  
  return (
    <Card raised fluid className='result-container'>
      <span className="forcast-title">{dealer}</span>
      <div className='horizontal-scroll'>
        <ReactDataSheet
          data={!data || data.length <= 3 ? [] : dataWithTotalCols}
          valueRenderer={renderCellContent}
          onCellsChanged={handleCellsChange}
        />
      </div>
    </Card>
  );
};

export const renderTable = ({
  rucFilter,
  isUserFromTDE,
  dealer,
  data,
  dates,
  loading,
  agenciesList,
  renderCellContent,
  handleCellsChange,
}) => {
  if (isUserFromTDE && rucFilter === dealerListForForcastSale[0].value) {
    return <ConsolidatedTable />;
  }
  return renderSpreadSheet({
    'dealer': dealer,
    'data': data,
    'dates': dates,
    'loading': loading,
    'agenciesList': agenciesList,
    'addTotalCols': addTotalCols,
    'renderCellContent': renderCellContent,
    'handleCellsChange': handleCellsChange,
  });
};

export const renderWeekUndefinedMessage = ({
  dates,
  rucFilter,
  yearFilter,
  monthFilter,
  searchClicked,
}) => {
  if (!dates.length && rucFilter && yearFilter && monthFilter && searchClicked) {
    return (
      <div>
        <Card raised fluid className='result-container'>
          <h1>No se tienen semanas definidas para este mes</h1>
        </Card>
      </div>
    );
  }
  return null;
};

